import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { setScannedTableId } from '../actions/actions';
import SearchIcon from '@mui/icons-material/Search';
import './navbar.scss';

const Navbar = ({ tableNo, setScannedTableId }) => {
  const [merchants, setMerchants] = useState([]);
  const [selectedMerchant, setSelectedMerchant] = useState(
    localStorage.getItem('selectedMerchantFilter') || 'all'
  );
  const [searchTerm, setSearchTerm] = useState(
    localStorage.getItem('foodSearchTerm') || ''
  );

  useEffect(() => {
    const API_URL = process.env.REACT_APP_API_URL;

    const fetchMerchants = async () => {
      try {
        const merchantId = localStorage.getItem('merchantId');

        const response = await fetch(`${API_URL}/foods/mfoods`, {
          headers: {
            merchantId,
          },
        });

        const data = await response.json();

        const merchantList = Array.isArray(data)
          ? data
              .map((item) => ({
                _id: item?.merchant?._id,
                name:
                  item?.merchant?.name ||
                  item?.merchant?.username ||
                  'Unknown Merchant',
              }))
              .filter((item) => item._id)
              .filter(
                (item, index, self) =>
                  index === self.findIndex((m) => m._id === item._id)
              )
              .sort((a, b) => a.name.localeCompare(b.name))
          : [];

        setMerchants(merchantList);
      } catch (error) {
        console.error('Error fetching merchants in Navbar:', error);
      }
    };

    fetchMerchants();
  }, []);

  const handleMerchantChange = (e) => {
    const value = e.target.value;
    setSelectedMerchant(value);
    localStorage.setItem('selectedMerchantFilter', value);

    window.dispatchEvent(
      new CustomEvent('merchantFilterChanged', { detail: value })
    );
  };

  const handleSearchChange = (e) => {
    const value = e.target.value;
    setSearchTerm(value);
    localStorage.setItem('foodSearchTerm', value);

    window.dispatchEvent(
      new CustomEvent('foodSearchChanged', { detail: value })
    );
  };

  return (
    <header className="navbar">
      <div className="leftside">
        <h1> {tableNo}</h1>
      </div>

      <div className="search">
        <div className="search-input-wrapper">
          <SearchIcon className="search-icon" />
          <input
            type="text"
            placeholder="Search food..."
            value={searchTerm}
            onChange={handleSearchChange}
          />
        </div>
      </div>

      <div className="rightside">
        {/* keep if later needed
        <select value={selectedMerchant} onChange={handleMerchantChange}>
          <option value="all">All Shop</option>
          {merchants.map((merchant) => (
            <option key={merchant._id} value={merchant._id}>
              {merchant.name}
            </option>
          ))}
        </select>
        */}
      </div>
    </header>
  );
};

const mapStateToProps = () => ({
  tableNo: localStorage.getItem('tableNo'),
});

const mapDispatchToProps = (dispatch) => ({
  setScannedTableId: (tableData) => dispatch(setScannedTableId(tableData)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Navbar);